import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ResponseStatusEnum } from 'src/app/shared/models/system/response-status.enum';
import { Globals } from 'src/app/shared/services/globals';
import { NewsService } from '../../sas/services/news.service';
import { News } from 'src/app/shared/models/DTO/News';
import { SubSpeciality } from 'src/app/shared/models/DTO/SubSpeciality';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.css']
})
export class NewsDetailsComponent implements OnInit {
  newsId: number;
  news: News = new News();
  currentDate: any;

  constructor(private _activatedRoute:ActivatedRoute, private router:Router, public _NewsService: NewsService,
    public globals: Globals, private toastr: ToastrService) { }

  ngOnInit() {

    this._activatedRoute.params.subscribe(a =>{
      this.newsId = a['newsId'];
    });

    var date = new Date();
    var months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو","يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
    var days = ["اﻷحد", "اﻷثنين", "الثلاثاء", "اﻷربعاء", "الخميس", "الجمعة", "السبت"];
    this.currentDate = days[date.getDay()] + ' ' + date.getDate() + ' ' + months[date.getMonth()] + ' ' + date.getFullYear();

    if(this.newsId){
      this._NewsService.GetNewsById(this.newsId).subscribe(
        (data:any) => {
          console.log("News data : " , data);
          if(data.status !=-1){
            this.news= data.data;
            if (this.news.pictureUrl){
              this.news.pictureUrl = `${environment.API_URL}/../${this.news.pictureUrl}`;
            }
            else{
              this.news.pictureUrl = '../../../assets/images/newspaper.jpg';
            }
          }
        },
        (error:any) =>{
          console.log(error);
          this.toastr.error("حدث خطأ ما.");
        });
   }
  }

}
